var exports = {
  "m": "LoadableComponent.module__inline___QnR1em",
  "p": "LoadableComponent.module__inlineIcon___QnR1em",
};

module.exports = exports;
